<template>
  <div class="about">
    <div class="introduction">
      <img src="./../assets/profile.jpg" alt="profile" class="introduction__image">
      <!-- <div class="profile__quotes">
        "LIVE AS IF YOU WERE TO DIE TOMORROW.<br>DREAM AS IF YOU WERE TO LIVE FOREVER."
      </div> -->
      <div class="introduction__content">
        <strong>I</strong>am a Japanese software engineer / tech geek / history nerd / future astronaut. As I grew up in multiple communities in multiple cities (7 cities in 3 countries, to be exact!), I realized that this world is one huge Cultural Mosaic. Billions of people have Billions of different stories behind. Now, it's time to write the story of my life.<br><br>What does your story look like? <a @click="scroll()">Share them with me!</a> I'm always looking for a key to open the next door.
      </div>
    </div>
    <div class="profile">
      <div class="profile__header about__header">PROFILE</div>
      <div class="profile__label">Date of Birth:</div>
      <div class="profile__content">21/10/1992</div>
      <div class="profile__label">Sex:</div>
      <div class="profile__content">Male</div>
      <div class="profile__label">Belief:</div>
      <div class="profile__content">Christian (Baptist)</div>
      <div class="profile__label">Location:</div>
      <div class="profile__content">Sapporo, Hokkaido, Japan</div>
      <div class="profile__content">Asahikawa, Hokkaido, Japan</div>
      <div class="profile__content">Munich, Germany</div>
      <div class="profile__content">Tokyo, Japan</div>
      <div class="profile__content">Kushiro, Hokkaido, Japan</div>
      <div class="profile__content">Columbus, Ohio, USA</div>
      <div class="profile__content">Kyoto, Japan</div>
    </div>
    <div class="skills">
      <div class="skills__header about__header">SKILLS</div>
      <span class="skills__skill">Ruby</span>
      <span class="skills__skill">Ruby on Rails</span>
      <span class="skills__skill">Firebase</span>
      <span class="skills__skill">Heroku</span>
      <span class="skills__skill">PHP</span>
      <span class="skills__skill">Wordpress</span>
      <span class="skills__skill">Perl</span>
      <span class="skills__skill">Python</span>
      <span class="skills__skill">ES8</span>
      <span class="skills__skill">React</span>
      <span class="skills__skill">Vue.js</span>
      <span class="skills__skill">MySQL</span>
      <span class="skills__skill">PostgreSQL</span>
      <span class="skills__skill">Docker</span>
      <span class="skills__skill">Hadoop</span>
      <span class="skills__skill">Linux</span>
      <span class="skills__skill">Git</span>
      <span class="skills__skill">HTML5</span>
      <span class="skills__skill">CSS3</span>
      <span class="skills__skill">jQuery</span>
      <span class="skills__skill">Google Apps Script</span>
    </div>
    <div class="links" id="links">
      <div class="links__header about__header">LINKS</div>
      <a href="https://github.com/andoshin11" class="links__link" target="_blank"><i class="fa fa-github" aria-hidden="true"></i></a>
      <a href="https://www.linkedin.com/in/shin-ando-95193972/" class="links__link" target="_blank"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a>
      <a href="https://www.instagram.com/andoshin11/" class="links__link" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
      <a href="https://twitter.com/andoshin11" class="links__link" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
      <a href="https://www.facebook.com/andoshin11" class="links__link" target="_blank"><i class="fa fa-facebook-official" aria-hidden="true"></i></a>
      <a href="http://www.justyo.co/ANDOSHIN11/" class="links__link" target="_blank"><i class="fa fa-square" aria-hidden="true"></i></a>
      <a href="mailto:shinglish11@gmail.com" class="links__link"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
      <a href="https://www.amazon.co.jp/gp/registry/wishlist/1GOD9AV7NRYPZ/ref=nav_wishlist_lists_1" class="links__link" target="_blank"><i class="fa fa-amazon" aria-hidden="true"></i></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
    }
  },
  methods: {
    scroll () {
      var el = document.getElementById('links')
      if (el) {
        window.scrollTo(window.scrollX, el.offsetTop)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$black: #2c3e50;
$green: #41BAA4;
$green-dark: #067e76;

body {
  font-size: 12px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: $green-dark;
  text-decoration: underline;
  cursor: pointer;
  &:hover{
    opacity: .7;
  }
}
.about {
  display: block;
  width: 60%;
  margin: auto;
  padding-bottom: 300px;
  &__header {
    font-size: 32px;
    line-height: 5;
    font-weight: bold;
  }
}

.introduction {
  &__content {
      text-align: left;
      font-size: 18px;
      line-height: 1.5;
      strong {
        color: $green;
        float: left;
        font-size: 58px;
        padding: 4px 10px 0 0px;
        line-height: 50px;
      }
  }
  &__image {
    width: 500px;
    height: 500px;
    border-radius: 50%;
    margin-bottom: 50px;
  }
  &__quotes {
    border: solid 1px $black;
    padding: 40px 40px;
    font-weight: bold;
    font-size: 28px;
    letter-spacing: 1px;
  }
}

.links {
  &__link {
    color: $black;
    font-size: 24px;
    margin-right: 20px;
    transition: .3s;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: $green;
    }
  }
}

.profile {
  &__label {
    font-weight: bold;
    color: $green-dark;
    margin-top: 20px;
    font-size: 22px;
    &:first-child{
      margin-top: 0;
    }
  }
  &__content {
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 1.5;
  }
}

.skills {
  &__skill {
    display: inline-block;
    border: 1px solid $black;
    border-radius: 3px;
    padding: 0 5px;
    font-size: 16px;
    line-height: 1.5;
    margin-right: 3px;
    margin-bottom: 6px;
  }
}
@media screen and (max-width: 767px) {
  .about {
    width: 100%;
    padding-bottom: 100px;
  }
  .introduction {
    &__image {
      width: 250px;
      height: 250px;
    }
    &__content {
      width: 85%;
      margin: auto;
      font-size: 16px;
      strong {
        font-size: 48px;
        line-height: 40px;
        padding-top: 7px;
      }
    }
  }
  .profile {
    &__label {
      font-size: 20px;
      margin-top: 16px;
    }
    &__content {
      font-size: 18px;
    }
  }
  .links {
    &__link {
      display: block;
      width: 50%;
      float: left;
      margin-right: 0;
      line-height: 3;
      font-size: 32px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// About.vue?6797a2a8